import React, { useState, useEffect } from 'react'
import addDays from 'date-fns/add_days'
import format from 'date-fns/format'
import { themeConWeb } from '@foodsby/nutrient'
import cn from 'classnames'
import styled from 'styled-components'
import { space } from 'styled-system'
const styles = themeConWeb

const NavSubDaily = ({
  todaysDate = format(new Date(), 'MM/DD/YYYY'),
  selectedDate,
  onChangeDay,
}) => {
  const numDays = 7
  const [days, setDays] = useState([])
  const [controlledIndex, setControlledIndex] = useState(-1)
  const [selected, setSelected] = useState({ ...days[0], index: 0 })
  const inactiveDays = ['Sat', 'Sun']

  useEffect(() => {
    const tempDays = [...Array(numDays).keys()]
    const days = tempDays.map(n => {
      const date = addDays(todaysDate, n)
      return {
        day: format(date, 'ddd'),
        selectedDate: format(date, 'YYYYMMDD'),
      }
    })

    setDays(days)
  }, [todaysDate])

  useEffect(() => {
    const index = days?.findIndex(d => d?.selectedDate === selectedDate)
    if (index >= 0 && index < numDays) {
      setControlledIndex(index)
    }
    if (typeof controlledIndex === 'number') {
      setSelected({ ...days[controlledIndex], index: controlledIndex })
    }
  }, [days, selectedDate, controlledIndex])

  return (
    <Component>
      <div className="-days">
        {days.map((day, index) => (
          <button
            className={cn({
              'is-selected': selected.index === index,
              'is-inactive': inactiveDays.includes(day.day),
            })}
            key={index}
            onClick={() => {
              setSelected({ ...day, index: index })
              day.selectedDate !== selectedDate && onChangeDay(day.selectedDate)
            }}
          >
            <span className="-day">{day.day}</span>
          </button>
        ))}
      </div>
    </Component>
  )
}

const Component = styled.nav`
  backdrop-filter: blur(10px);
  background-color: ${styles.color.three};
  box-sizing: border-box;
  box-shadow: ${styles.elevation1};
  color: ${styles.color.white};
  display: flex;
  font-family: ${styles.fonts.primary} !important;
  justify-content: center;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 3;
  ${space}


  & .-days {
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    max-width: 358px;
    padding: calc(${styles.baseUnit} * 2) calc(${styles.baseUnit} * 2);
    position: relative;
    width: 100%;
  }
  & button {
    position: relative;

    &::after {
      background-color: transparent;
      bottom: -8px;
      content: '';
      display: block;
      height: 0;
      left: 11px;
      position: absolute;
      transition: 0.4s;
      width: calc(${styles.baseUnit} * 5);
      z-index: 2;
    }
  }
  & .-day {
    align-items: center;
    border-radius: 50%;
    border: 1px dotted transparent;
    bottom: 0;
    color: ${styles.color.brandSecondaryTint6};
    cursor: pointer;
    display: flex;
    font-family: ${styles.fonts.primary};
    font-size: ${themeConWeb.fontSizes.base}
    font-weight: bold;
    height: calc(${styles.baseUnit} * 10);
    justify-content: center;
    min-width: calc(${styles.baseUnit} * 10);
    transition: 0.2s;

    &:hover {
      border: 1px solid ${styles.color.white};
    }
  }

  /* States */
  .is-selected {
    .-day {
      background-color: ${styles.color.white};
      color: ${styles.color.brandSecondary};
    }

    &::after {
      background-color: ${styles.color.white};
      height: 2px;
    }
  }

  .is-inactive {
    opacity: 0.5;
  }
`
export default NavSubDaily
